import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as S from './styles';

export class VideoPlay extends Component {
  state = {
    videoPlaying: null,
  };

  videoPlayHandle = (video) => {
    const { state } = this;
    const videos = document.getElementsByClassName('videos');

    if (state.videoPlaying !== null) {
      try {
        document.exitPictureInPicture();
      } catch (error) {}
    }

    this.setState({
      videoPlaying: video.currentTarget,
    });

    Array.from(videos).forEach((item) => {
      if (item !== video.currentTarget) {
        item.pause();
      }
    });
  };

  videoStopHandle = (video) => {
    const { state } = this;
    if (isEqual(video.currentTarget, state.videoPlaying)) {
      this.setState({
        videoPlaying: null,
      });
    }
  };

  render() {
    const {
      props: { media, video, hideVideo, noClose, noDownload },
    } = this;

    const tagVideo = document.querySelector('.videos');
    const isPaused = tagVideo && tagVideo.paused;
    const isEnded = tagVideo && tagVideo.ended;

    return (
      <S.VideoOverwrite isPaused={isPaused} isEnded={isEnded}>
        {!noClose && (
          <S.CloseVideo className="close-video" onClick={hideVideo}>
            <FontAwesomeIcon icon={['fal', 'times']} />
          </S.CloseVideo>
        )}
        <video
          autoPlay
          poster={media.thumbnail_url}
          preload="metadata"
          id={media.id}
          width="95%"
          height="95%"
          className="videos"
          controls
          onPlay={this.videoPlayHandle}
          onPause={this.videoStopHandle}
        >
          <source src={video} type="video/mp4" />
        </video>
        {!noDownload && (
          <S.LinkDownload href={video} title="Download">
            <FontAwesomeIcon icon={['fal', 'download']} />
          </S.LinkDownload>
        )}
      </S.VideoOverwrite>
    );
  }
}

export default VideoPlay;
